window.$mm_obligations_result = [];
window.$mm_obligations_didUpdateChange = true;
window.$mm_obligations_treeChangeStatus = false;
window.$mm_obligations_treeList = [];
window.$mm_obligations_page_number = 1;
window.$mm_obligations_newInsertId = [];
window.$mm_obligations_Glist = [];
window.$mm_obligations_content = [];
window.$mm_obligations_filter_code = [];
window.$mm_obligations_filter_omschrijving = [];
window.$mm_obligations_filter_boekingsnummer = [];
window.$mm_obligations_filter_organisatie = [];
window.$mm_obligations_filter_opdrachtgever = [];
window.$mm_obligations_filter_directievoeder = [];
window.$mm_obligations_filter_toezichthouder = [];
window.$mm_obligations_filter_eenheid = [];
window.$mm_obligations_filter_werkplan = [];
window.$mm_obligations_filter_budget = [];
window.$mm_obligations_gvv = 1;
window.$mm_obligations_filterMaatregelenIsActive = [];
window.$mm_obligations_filterPlannigIsActive = [];
window.$mm_obligations_filterContent = [];
window.$mm_obligations_filterClickStatus = false;
window.$mm_obligations_scroll_change = false;
window.$mm_obligations_columnList = [];
window.$mm_obligations_selectedIds = null;
window.$mm_obligations_token = null;
window.$mm_obligations_table_total_row_count = 0;
window.$mm_obligations_columnListPure = null;
window.$mm_obligations_refresh = function (){};
window.$mm_obligations_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$mm_obligations_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
];

window.$mm_obligations_units_column_order_post_model = {
  client_identification: "",
  reference:"",
  code: "COLUMN_ORDER",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>obligations",
        column_list: [
          "checkbox",
          "active",
          "Code",
          "Omschrijving",
          "Boekingsnummer",
          "Datum aanvang",
          "Datum oplevering",
          "Organisatie",
          "Opdrachtgever",
          "Directievoeder",
          "Toezichthouder",
          "Eenheid",
          "Werkplan",
          "Budget",
        ],
      },
    ],
  },
};
